import { render, staticRenderFns } from "./themRoughlyManagement.vue?vue&type=template&id=4c28bce0&scoped=true&"
import script from "./themRoughlyManagement.vue?vue&type=script&lang=js&"
export * from "./themRoughlyManagement.vue?vue&type=script&lang=js&"
import style0 from "./themRoughlyManagement.vue?vue&type=style&index=0&id=4c28bce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28bce0",
  null
  
)

export default component.exports